// extracted by mini-css-extract-plugin
export default {"root":"ProductSubscription_root__x4S1n"};